import React from 'react';
import { connect } from 'react-redux';
import reduxForm from 'redux-form/lib/reduxForm';
import queryString from 'query-string';
import {
  submitVanitySlug,
  fetchTempVanitySlugFromPodcastName,
  ONBOARDING_VANITY_URL_FORM,
} from '../../onboarding';
import OnboardingCreateAccount from '../OnboardingCreateAccount';

const getFeedUrlFromLocation = location => {
  const { feedUrl } = queryString.parse(location.search);

  return feedUrl ? decodeURIComponent(feedUrl) : null;
};

const mapDispatchToProps = dispatch => ({
  actions: {
    fetchTempVanitySlugFromPodcastName: () =>
      dispatch(fetchTempVanitySlugFromPodcastName()),
  },
  onSubmit: data => dispatch(submitVanitySlug(data)),
});

const mapStateToProps = ({ onboarding }, { location }) => ({
  feedUrl: getFeedUrlFromLocation(location),
  enableReinitialize: true,
  initialValues: {
    vanitySlug: onboarding.vanitySlug,
  },
  onboarding,
});

// Decorate the form component
const OnboardingCreateAccountWithForm = reduxForm({
  form: ONBOARDING_VANITY_URL_FORM,
})(OnboardingCreateAccount);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardingCreateAccountWithForm);
